import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// GH-branded header for the /assets deck — replaces the legacy Solve/Invest chrome.
const AssetsHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 20);
    on();
    window.addEventListener('scroll', on);
    return () => window.removeEventListener('scroll', on);
  }, []);
  return (
    <header
      className={`fixed top-0 z-50 w-full transition-colors duration-300 ${
        scrolled ? 'bg-[#32292F]/85 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        <button
          onClick={() => navigate('/#ip')}
          data-testid="assets-nav-logo"
          className="gh-display text-[15px] font-semibold tracking-[0.18em] text-white"
        >
          GENERAL <span className="text-[#4C8DFF]">HARMONICS</span>
        </button>
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/#ip')}
            data-testid="assets-back-link"
            className="hidden items-center gap-1.5 text-sm text-white/70 transition-colors hover:text-white sm:inline-flex"
          >
            <ArrowLeft size={15} /> Back to site
          </button>
          <button
            onClick={() => navigate('/#pilot')}
            data-testid="assets-pilot-cta"
            className="rounded-full bg-[#0059FF] px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-[#0047CC]"
          >
            Start a Pilot
          </button>
        </div>
      </div>
    </header>
  );
};

export default AssetsHeader;
